import React from "react";
import {
  CommonFormItemWithLabel,
  CommonModal,
} from "../../../../../components/common/MoleculesCommonComponent";
import {
  CommonButton,
  CommonFlexContainer,
  CommonTextArea,
} from "../../../../../components/common/AtomCommonComponents";
import { Form } from "antd";
import ValidationUtils from "../../../../../utils/ValidationUtils";

interface CancelReasonModalTypes {
  isCancelReasonModalVisible: boolean;
  onCloseModal: () => void;
  onSubmitReason: (reason: any) => void;
}

const CancelReasonModal = (props: CancelReasonModalTypes) => {
  const [form] = Form.useForm();
  const { isCancelReasonModalVisible, onCloseModal, onSubmitReason } = props;

  const onCancelModal = () => {
    form.resetFields();
    onCloseModal();
  };

  const onSubmit = async () => {
    const { reason } = await form.validateFields();
    onSubmitReason(reason);
  };

  return (
    <CommonModal
      margintop="20px"
      maskClosable={false}
      visible={isCancelReasonModalVisible}
      onCancel={onCancelModal}
      footer={null}
      closable={false}
    >
      <Form form={form} validateTrigger="onChange">
        <CommonFlexContainer width="100%" gap="10px" column alignCenter>
          <div id="select" style={{ width: "90%" }}>
            <CommonFormItemWithLabel
              name={"reason"}
              label={"Reason for Cancellation"}
              rules={[
                {
                  required: true,
                  message: "Reason for Cancellation is required.",
                },
                { validator: ValidationUtils.validateInput },
              ]}
            >
              <CommonTextArea
                rows={5}
                placeholder="Input Reason for Cancellation"
              />
            </CommonFormItemWithLabel>
          </div>
          <CommonFlexContainer
            width="100%"
            alignCenter
            justifyCenter
            gap="10px"
          >
            <CommonButton
              key="cancel"
              borderradius="100px"
              onClick={onCancelModal}
            >
              Cancel
            </CommonButton>
            <CommonButton
              background="primary"
              color="white"
              borderradius="100px"
              onClick={onSubmit}
            >
              Save
            </CommonButton>
          </CommonFlexContainer>
        </CommonFlexContainer>
      </Form>
    </CommonModal>
  );
};

export default CancelReasonModal;
